module.exports = __webpack_public_path__ + "static/media/Screenshot_8-thumb.bcfbbd2b.png";